/* eslint-disable */
import * as util from "@/api/member";
import * as utilLogin from "@/api/login";

const state = {
    numActiveVoucherTotal: 0,
    numLicenseTotal: 0,
    numAgentTotal: 0,
    numMessageTotal: 0,
    numMessageSuccessTotal: 0,
    numMessageErrorTotal: 0,
    numMessagePendingTotal: 0,
};


const mutations = {
    SET_numActiveVoucherTotal: (state, value) => {
        state.numActiveVoucherTotal = value
    },
    SET_numLicenseTotal: (state, value) => {
        state.numLicenseTotal = value
    },
    SET_numAgentTotal: (state, value) => {
        state.numAgentTotal = value
    },
    SET_numMessageTotal: (state, value) => {
        state.numMessageTotal = value
    },
    SET_numMessageSuccessTotal: (state, value) => {
        state.numMessageSuccessTotal = value
    },
    SET_numMessageErrorTotal: (state, value) => {
        state.numMessageErrorTotal = value
    },
    SET_numMessagePendingTotal: (state, value) => {
        state.numMessagePendingTotal = value
    },
};

const actions = {
    updateBank({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateBank(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getTimezones() {
        return new Promise((resolve, reject) => {
            util.getTimezones().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updatePassword({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updatePassword(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateTimezone({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateTimezone(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateProfile({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateProfile(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    monthlyAgentsStatistic({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.monthlyAgentsStatistic(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    summaryAgents({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.summaryAgents(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    monthlyActiveLicenses({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.monthlyActiveLicenses(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getActiveVoucherTotal({ commit }) {
        return new Promise((resolve, reject) => {
            util.getActiveVoucherTotal().then(response => {
                const { data } = response;
                commit("SET_numActiveVoucherTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getLicenseTotal({ commit }) {
        return new Promise((resolve, reject) => {
            util.getLicenseTotal().then(response => {
                const { data } = response;
                commit("SET_numLicenseTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAgentTotal({ commit }) {
        return new Promise((resolve, reject) => {
            util.getAgentTotal().then(response => {
                const { data } = response;
                commit("SET_numAgentTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessageTotal({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessageTotal(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessageTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessageSuccess({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessageSuccess(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessageSuccessTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessagePending({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessagePending(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessagePendingTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessageError({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessageError(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessageErrorTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listDataMemberExcel({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.listDataMemberExcel(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    //member
    listDataMember({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.listDataMember(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listLicenseActiveExcel({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.listLicenseActiveExcel(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listLicenseActive({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.listLicenseActive(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listReseller({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.listReseller(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSaldoReseller({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.listSaldoReseller(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listDownline({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.listDownline(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    // Validasi ulang password admin. Sengaja TIDAK memakai action
    // login/loginMemberValidation karena action tersebut menghapus sesi admin.
    validateAdminCredential({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            utilLogin.validateAdminCredential(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    confirmMemberAccount({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.confirmMemberAccount(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createMemberImpersonation({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.createMemberImpersonation(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/member.js